import { Box, Button, Dialog, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { COLORS } from "../settings/themeSettings";


const styles = {
    container: {
        // border: '1px solid blue',
        minHeight: '1000px',
        width: '1000px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: COLORS.gray[100],
        padding: '15px',
        borderRadius: '5px',
        height: 'fit-content'

    },
    pathtitle: {
        fontSize: '1em',
        fontWeight: 'bold',
        padding: '0 10px',
        width: '100%',
        color: COLORS.tertiary
    },
    path: {
        width: '300px',
        height: '100%',
        //  border: '1px solid red'
    }
}



function AddBillDialog(props) {
    const { onClose, open } = props;

    const [motif, setMotif] = useState('');
    const [designation, setDesignation] = useState('');
    const [montantCFA, setMontantCFA] = useState('');

    
    useEffect(() => {
        if (open) {
            if (props.bill) {
                setMotif(props.bill.motif || '');
                setDesignation(props.bill.libelle || '');
                setMontantCFA(props.bill.montant || '');
            } else {
                setMotif('');
                setDesignation('');
                setMontantCFA('');
            }
        }
    }, [open, props.bill]);

    const handleClose = (event, reason) => {
        if (reason && reason === "backdropClick")
            return;
        onClose();
    };


    const addBill = () => {
        const bill = {
            motif: motif,
            libelle: designation,
            montant: montantCFA
        }

        onClose(bill);
    }


    return (
        <Dialog onClose={handleClose} open={open} maxWidth={'lg'} PaperProps={{ sx: { minWidth: '700px' } }} >
            <DialogTitle
                sx={{
                    backgroundColor: COLORS.secondary,
                    color: 'white',
                    mb: 5
                }}
            >{props.bill ? "Modifier les frais" : "Ajouter des frais"}</DialogTitle>


            <Stack
                justifyContent="center"
                alignItems="center"
                sx={{
                    width: '400px',
                    padding: '10px 0'

                }}

            >

                <Box
                    width={'300px'}
                >
                    <Typography
                        variant="p"
                        sx={styles.pathtitle}

                    >
                        Information sur la facture
                    </Typography>

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="motif"
                        label="MOTIF"
                        InputProps={{ style: { height: '45px' } }}
                        color="secondary"
                        focused
                        placeholder='MOTIF de la facture'
                        onChange={(e) => setMotif(e.target.value)}
                        value={motif}
                    />

                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="designation"
                        label="Désignation"
                        InputProps={{ style: { height: '45px' } }}
                        color="secondary"
                        focused
                        placeholder='Désignation détaillée'
                        onChange={(e) => setDesignation(e.target.value)}
                        value={designation}
                        multiline
                        rows={3}
                    />

                    <TextField
                    type="number"

                        margin="normal"
                        required
                        fullWidth
                        name="Montant en CFA"
                        label="Montant en CFA"
                        InputProps={{ style: { height: '45px' } }}
                        color="tertiary"
                        focused
                        placeholder='Montant en CFA'
                        onChange={(e) => setMontantCFA(e.target.value)}
                        value={montantCFA}
                    />






                </Box>
            </Stack>
            <Stack
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                sx={{
                    mt: 4,
                    pb: 5,
                    pr: 2
                }}

            >


                <Button
                    variant="contained"
                    color="primary"
                    style={{ color: 'white' }}
                    onClick={handleClose}
                >
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={addBill}
                >
                    Valider
                </Button>

            </Stack>

        </Dialog>
    );
}

export default AddBillDialog;

